import axios from "./../../config/axios"
export function reportingPeriodProfitLose(params) {
    return axios().get("/ledger/reporting-period-profit-loss", {params})
}
